import { roles } from "shared/constants/Constants.js";

const settlementRoutes = {
  dashboard: [
    {
      path: "settlement-list",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "settlement-list" */
          "../../feature/settlement/SettlementList.js"
        ),
      authorized: [roles.ADMIN, roles.COMMERCIAL, roles.FINANCE],
      sidebarGroup: "updates",
      sidebarLabel: "List",
    },
    {
      path: "updatesList",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "variables-list" */
          "../../feature/settlement/variables/VariablesNew.js"
        ),
      authorized: [roles.ADMIN],
      sidebarGroup: "updates",
      sidebarLabel: "Variables",
    },
    {
      path: "refundList",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "refund-list" */
          "../../feature/settlement/RefundList.js"
        ),
      authorized: [roles.ADMIN, roles.FINANCE, roles.COMMERCIAL],
      sidebarGroup: "updates",
      sidebarLabel: "Refund List",
    },
    {
      path: "bad_debt",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "bad-debt" */
          "../../feature/settlement/BadDept.js"
        ),
      authorized: [roles.HUB_MANAGER, roles.FINANCE, roles.ADMIN],
    },
    {
      path: "vendorOrgList",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "vendor-org-list" */
          "../../feature/settlement/VendorOrgList.js"
        ),
      authorized: [roles.ADMIN],
      sidebarGroup: "updates",
      sidebarLabel: "Vendor Org List",
    },
    {
      path: "TPW",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "tpw" */
          "../../feature/settlement/Tpw.js"
        ),
      authorized: [roles.ADMIN, roles.COMMERCIAL],
      sidebarGroup: "updates",
      sidebarLabel: "TPW",
    },
    {
      path: "waiver-upload",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "tpw" */
          "../../feature/settlement/waiver-upload/WaiverUpload.page.js"
        ),
      authorized: [roles.ADMIN, roles.COMMERCIAL],
      sidebarGroup: "updates",
      sidebarLabel: "Waiver Upload",
    },
  ],
  standalone: [
    {
      path: "/settlement/statement/:settlementId",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "settlement-statement" */
          "./SettlementStatement.js"
        ),
    },
  ],
};

export default settlementRoutes;
